import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { IAuditModel } from '@/models';

import { http } from './http';
import { IGetParams, IPaginatedListResponse } from './types';

export const AuditLogApi = {
  getAuditLogs: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IAuditModel>>> => {
    return http.get(`api/${ApiVersion.V1}/audit-logs`, { params });
  },
};
